import React from 'react';

import css from './ListingPage.module.css';
import ListingImageModalGallery from './ListingImageGallery/ListingImageModalGallery';

const SectionGallery = props => {
  const { listing, variantPrefix, onManageDisableScrolling, photosLimit  } = props;
  const images = photosLimit > 0 ? (listing?.images || [])?.slice(0, photosLimit) : [];
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageModalGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        onManageDisableScrolling ={onManageDisableScrolling }
      />
    </section>
  );
};

export default SectionGallery;
